import { type FC, type ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography } from '@mui/material'

interface WizardHeaderProps {
  readonly icon: ReactNode
  readonly title: string
  readonly description: ReactNode
  readonly largeDescription?: boolean
}

export const WizardHeader: FC<WizardHeaderProps> = ({
  icon,
  title,
  description,
  largeDescription = false,
}) => (
  <Box sx={wizardHeaderContainerSx}>
    <Box sx={wizardIconWrapperSx}>{icon}</Box>
    <Typography variant="h5" sx={wizardTitleSx}>
      {title}
    </Typography>
    <Typography sx={largeDescription ? wizardLargeDescriptionSx : wizardDescriptionSx}>
      {description}
    </Typography>
  </Box>
)

const wizardHeaderContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  py: 6,
}

const wizardIconWrapperSx: SxProps<Theme> = {
  mb: 3,
  '& > svg': {
    fontSize: 64,
    color: 'primary.main',
  },
}

const wizardTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 2,
}

const wizardDescriptionSx: SxProps<Theme> = {
  color: 'text.secondary',
  maxWidth: 400,
  mb: 4,
  lineHeight: 1.6,
}

const wizardLargeDescriptionSx: SxProps<Theme> = {
  color: 'text.secondary',
  maxWidth: 400,
  mb: 1,
  lineHeight: 1.6,
  fontSize: '1rem',
}
